/**
 * `<Transition>` hooks for a drawer that slides open and shut.
 *
 * `height: auto` cannot be animated: measure the panel, animate between 0 and
 * that height, then hand the height back to `auto` — an open panel has to stay
 * free to grow when its content changes under it (real-time departures, an
 * alert description reflowing on rotation).
 *
 * The element these are bound to must clip its overflow and carry no padding of
 * its own, so that it collapses to exactly 0.
 */

export function expandDrawer(el: Element) {
  const panel = el as HTMLElement;
  const target = panel.scrollHeight;
  panel.style.height = '0';
  // Force a reflow so the browser animates from 0 rather than jumping to target.
  void panel.offsetHeight;
  panel.style.height = `${target}px`;
}

export function releaseDrawerHeight(el: Element) {
  (el as HTMLElement).style.height = '';
}

export function collapseDrawer(el: Element) {
  const panel = el as HTMLElement;
  panel.style.height = `${panel.scrollHeight}px`;
  void panel.offsetHeight;
  panel.style.height = '0';
}
